
import React from 'react';

const VehicleCollectionImportantNotes: React.FC = () => {
  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      <h4 className="font-semibold mb-3">Important Notes:</h4>
      <ul className="space-y-2 text-sm text-gray-700">
        <li className="flex items-start">
          <span className="w-2 h-2 bg-honeycomb rounded-full mt-2 mr-3 flex-shrink-0"></span>
          Please arrive 15 minutes before your scheduled time
        </li>
        <li className="flex items-start">
          <span className="w-2 h-2 bg-honeycomb rounded-full mt-2 mr-3 flex-shrink-0"></span>
          Bring your driving license
        </li>
        <li className="flex items-start">
          <span className="w-2 h-2 bg-honeycomb rounded-full mt-2 mr-3 flex-shrink-0"></span>
          Vehicle inspection will take approximately 30 minutes
        </li>
        <li className="flex items-start">
          <span className="w-2 h-2 bg-honeycomb rounded-full mt-2 mr-3 flex-shrink-0"></span>
          You'll receive your vehicle keys and documentation
        </li>
      </ul>
    </div>
  );
};

export default VehicleCollectionImportantNotes;
